<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name" />

    <div class="template-block">
      <div class="block-title">联营配置模板</div>
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.store_cooperation_config_add)"
        type="primary"
        size="small"
        @click="handleCreate"
      >
        新增
      </el-button>
    </div>

    <el-row :gutter="16" class="card-list">
      <el-col
        v-for="item in pageList"
        :key="item.id"
        :span="6"
        class="card-list-item"
      >
        <el-card shadow="hover" class="template-card">
          <div class="card-head">
            <span class="card-title">收益共享</span>
            <el-tag
              v-if="item.isDefault"
              size="medium"
              type="primary"
              class="default-tag"
            >
              默认
            </el-tag>
          </div>

          <div class="card-body">
            <div
              v-for="(rule, idx) in item.shareList || []"
              :key="`${item.id}-${rule.sortNo ?? idx}`"
              class="rule-item"
            >
              <span>出资比例 {{ rule.capitalRatio }}%</span>
              <span>收益率 {{ rule.incomeRate }}%</span>
            </div>
          </div>

          <div class="card-footer">
            <div class="template-name">{{ item.tplName || "-" }}</div>
            <div class="card-actions">
              <el-link
                v-show="!item.isDefault && isShowBtn(AUTH_BTN.store_cooperation_config_set_default)"
                :underline="false"
                type="primary"
                @click="handleSetDefault(item)"
              >
                设为默认
              </el-link>
              <el-link
                v-show="isShowBtn(AUTH_BTN.store_cooperation_config_edit)"
                :underline="false"
                type="primary"
                @click="handleEdit(item)"
              >
                编辑模板
              </el-link>
              <el-link
                v-show="isShowBtn(AUTH_BTN.store_cooperation_config_detail)"
                :underline="false"
                type="primary"
                @click="handleDetail(item)"
              >
                查看详情
              </el-link>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="table.currentPage"
        :page-size="table.pageSize"
        :total="table.total"
      />
    </div>

    <EditDialog
      :visible.sync="editDialog.visible"
      :mode="editDialog.mode"
      :initial-data="editDialog.form"
      @submit="submitEditDialog"
      @close="resetEditDialog"
    />

    <DetailDialog
      :visible.sync="detailDialog.visible"
      :detail-data="detailDialog.data"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import EditDialog from "./components/edit-dialog.vue";
import DetailDialog from "./components/detail-dialog.vue";
import {
  addJointTplAPI,
  editJointTplAPI,
  editJointTplDefaultAPI,
  getJointTplDetailAPI,
  getJointTplPageAPI,
} from "./api";

export default {
  name: "StoreCooperationConfig",
  mixins: [authBtnMixin],
  components: {
    EditDialog,
    DetailDialog,
  },
  data() {
    return {
      table: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      pageList: [],
      editDialog: {
        visible: false,
        mode: "create",
        editId: null,
        form: {
          templateName: "",
          ruleList: [],
        },
      },
      detailDialog: {
        visible: false,
        data: {
          tplName: "",
          tplType: null,
          isDefault: null,
          status: null,
          shareList: [],
        },
      },
    };
  },
  watch: {
    "table.currentPage"() {
      this.getList();
    },
    "table.pageSize"() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      try {
        const res = await getJointTplPageAPI({
          page: this.table.currentPage,
          pageSize: this.table.pageSize,
        });
        this.pageList = res.list || [];
        this.table.total = res.total || 0;
      } catch {
        this.pageList = [];
        this.table.total = 0;
      }
    },
    handleCreate() {
      this.editDialog.mode = "create";
      this.editDialog.editId = null;
      this.editDialog.form = {
        templateName: "",
        ruleList: [
          { capitalRatio: null, incomeRate: null },
          { capitalRatio: null, incomeRate: null },
          { capitalRatio: null, incomeRate: null },
        ],
      };
      this.editDialog.visible = true;
    },
    handleSetDefault(item) {
      this.$confirm("确认将该模板设为默认模板吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // if (item.id == null || item.id === "") {
          //   this.$message.warning("缺少模板信息");
          //   return;
          // }
          try {
            await editJointTplDefaultAPI({
              id: Number(item.id),
            });
            this.$message.success("设置成功");
            this.getList();
          } catch {
            // 错误提示由 http 统一处理
          }
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },
    handleEdit(item) {
      this.editDialog.mode = "edit";
      this.editDialog.editId = item.id;
      this.editDialog.form = {
        templateName: item.tplName || "",
        ruleList: (item.shareList || []).map((rule) => ({ ...rule })),
      };
      this.editDialog.visible = true;
    },
    async handleDetail(item) {
      if (item.id == null || item.id === "") {
        this.$message.warning("缺少模板信息");
        return;
      }
      try {
        const detail = await getJointTplDetailAPI({
          id: item.id,
        });
        this.detailDialog.data = {
          ...detail,
          tplName: detail.tplName != null ? detail.tplName : item.tplName || "",
          shareList: detail.shareList || [],
        };
        this.detailDialog.visible = true;
      } catch {
        // 错误提示由 http 统一处理
      }
    },
    async submitEditDialog(formData) {
      if (this.editDialog.mode === "create") {
        try {
          const shareList = (formData.ruleList || []).map((item) => ({
            capitalRatio: Number(item.capitalRatio),
            incomeRate: Number(item.incomeRate),
          }));
          await addJointTplAPI({
            tplName: String(formData.templateName || "").trim(),
            shareList,
          });
          this.$message.success("新增成功");
          this.editDialog.visible = false;
          this.table.currentPage = 1;
          this.getList();
        } catch {
          // http 已提示
        }
        return;
      }
      try {
        if (this.editDialog.editId == null || this.editDialog.editId === "") {
          this.$message.warning("缺少模板信息");
          return;
        }
        const shareList = (formData.ruleList || []).map((item) => {
          const row = {
            capitalRatio: Number(item.capitalRatio),
            incomeRate: Number(item.incomeRate),
          };
          if (item.id != null && item.id !== "") {
            row.id = Number(item.id);
          }
          return row;
        });
        await editJointTplAPI({
          id: Number(this.editDialog.editId),
          tplName: String(formData.templateName || "").trim(),
          shareList,
        });
        this.$message.success("编辑成功");
        this.editDialog.visible = false;
        this.getList();
      } catch {
        // http 已提示
      }
    },
    resetEditDialog() {
      this.editDialog.mode = "create";
      this.editDialog.editId = null;
      this.editDialog.form = {
        templateName: "",
        ruleList: [],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.template-block {
  margin-bottom: 16px;

  .block-title {
    color: #303133;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
  }
}

.card-list-item {
  margin-bottom: 16px;
}

.template-card {
  .card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 24px;
    margin-bottom: 10px;

    .card-title {
      font-size: 14px;
      color: #303133;
      font-weight: 600;
    }

    .default-tag {
      font-size: 13px;
      font-weight: 600;
      padding: 0 10px;
      height: 24px;
      line-height: 22px;
      border-radius: 6px;
    }
  }

  .card-body {
    height: 140px;
    border: 1px solid #ebeef5;
    padding: 8px 10px;
    margin-bottom: 10px;
    overflow-y: auto;

    .rule-item {
      line-height: 28px;
      color: #606266;
      border-bottom: 1px dashed #ebeef5;
      display: flex;
      justify-content: space-between;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .card-footer {
    .template-name {
      font-size: 14px;
      color: #303133;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .card-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
      flex-wrap: wrap;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
}
</style>
